import { z } from 'zod';

export const zMapLayer = z.enum([
  'PARKING_FACILITY',
  'PARK_AND_RIDE_FACILITY',
  'PICKUP_PARKING_FACILITY',
  'TRAIN_STATION',
  'BUS_STATION',
]);

export const MapLayer = zMapLayer.enum;

export type MapLayer = z.infer<typeof zMapLayer>;
